import React, { useState, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import authService from "../services/discordAuth";
import { trackEvent } from "../utils/analytics";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation, Trans } from "react-i18next";
import "./PartnerLandingPage.css";

const PARTNER_CONFIG = {
  // rincko: {
  //   name: "Rincko",
  //   avatar:
  //     "https://yt3.googleusercontent.com/_kcEpSXKnvJau2QiaG96Tj3NhNyi7XPb283RiyTBewnLxEApz8FWAhY0fiKmWdq_ySSZlDF_WqU=s160-c-k-c0x00ffffff-no-rj",
  //   banner:
  //     "https://yt3.googleusercontent.com/yd9bTvOAGa3-ToQQxpfbwYrpvqwvc_O4s8-CZlDulybz7GBjvWSsQzZcVsrL9-t5-8RZyB63=w1707-fcrop64=1,00005a57ffffa5a8-k-c0xffffffff-no-nd-rj",
  //   description:
  //     "Em parceria com o Rincko, trouxemos benefícios exclusivos para seus inscritos turbinarem seus bots no BotGate!",
  //   links: {
  //     premium: "https://buy.stripe.com/bJe5kC7i4fmUffAgmK1Nu01",
  //     business: "https://buy.stripe.com/aFa4gybykcaI5F0fiG1Nu00",
  //   },
  //   socials: {
  //     youtube: "https://www.youtube.com/@rinckodev",
  //     instagram: "https://www.instagram.com/rinckodev/",
  //     github: "https://www.github.com/rinckodev",
  //     discord: "https://www.discord.gg/tTu8dGN",
  //   },
  //   color: "#eb459e",
  // },
  // lan_code: {
  //   name: "Lan Code",
  //   avatar: "https://yt3.googleusercontent.com/8JpGsSP6_RODyGfur0VgcLjhe1l4VKkVYHFWd_q6847w4JNex7eZhFXb0NL-29lnpCf8RORW=s160-c-k-c0x00ffffff-no-rj",
  //   banner: "https://yt3.googleusercontent.com/JbJatULmWrJxiJzWpSb-HEfH1gHy7v8VTCo8gs2iJQ_LWScqotQo7FdFmNIGrKYrAGI7ZIMIUQ=w1707-fcrop64=1,00005a57ffffa5a8-k-c0xffffffff-no-nd-rj",
  //   description: "Em parceria com o Lan Code, trouxemos benefícios exclusivos para seus inscritos turbinarem seus bots no BotGate!",
  //   links: {
  //     premium: "https://buy.stripe.com/00w14mfOAdeMaZkday1Nu02",
  //     business: "https://buy.stripe.com/bJe4gy45SfmU1oK9Ym1Nu03",
  //   },
  //   socials: {
  //     youtube: "https://www.youtube.com/@lan_code",
  //     instagram: "https://www.youtube.com/@lan_code",
  //     github: "https://github.com/irlanferreira",
  //     discord: "https://www.discord.gg/lanhouse",
  //   },
  //   color: "#4c295f",
  // },
};

function PartnerLandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { partnerName } = useParams();

  // Busca o parceiro na config, se não achar, manda pra página de parceiros geral
  const partner = PARTNER_CONFIG[partnerName?.toLowerCase()];

  // Hook de título (só executa se o parceiro existir)
  usePageTitle(partner ? `BotGate × ${partner.name}` : "BotGate Parcerias");

  const [user, setUser] = useState(null);
  const [bots, setBots] = useState([]);
  const [selectedBotId, setSelectedBotId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  useEffect(() => {
    if (!partner) {
      navigate("/partners");
    }
  }, [partner, navigate]);

  useEffect(() => {
    if (partner && authService.isAuthenticated()) {
      const userData = authService.getUser();

      setUser(userData);
      fetchUserBots(userData.id);
    } else {
      setLoading(false);
    }
  }, [partner]);

  // Se o parceiro não existe, não renderiza nada enquanto o useEffect faz o redirect
  if (!partner) return null;

  // Sanitiza a cor para 6 dígitos (caso venha com alpha ou sem #)
  const sanitizeColor = (hex) => {
    if (!hex) return "#eb459e";
    let color = hex.replace("#", "");
    if (color.length > 6) color = color.substring(0, 6);
    return `#${color}`;
  };

  const purePartnerColor = sanitizeColor(partner.color);

  const fetchUserBots = async (userId) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/user/my-bots?userId=${userId}&viewerId=${userId}`);
      const data = await response.json();
      if (data.success) {
        const approvedOnly = (data.bots || []).filter((bot) => bot.status === "approved");
        setBots(approvedOnly);
        if (approvedOnly.length > 0) setSelectedBotId(approvedOnly[0].id);
      }
    } catch (err) {
      console.error("Erro ao buscar bots:", err);
      setError("Não foi possível carregar seus bots.");
    } finally {
      setLoading(false);
    }
  };

  const handlePartnerCheckout = async (tier) => {
    if (!authService.isAuthenticated()) {
      authService.login();
      return;
    }

    if (!selectedBotId) {
      alert("Por favor, selecione um bot primeiro!");
      return;
    }

    setLoading(true);
    try {
      const token = authService.getAccessToken();
      const response = await fetch(`${BACKEND_URL}/api/bots/${selectedBotId}/create-checkout-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          tier: tier,
          partner: partnerName.toLowerCase(), // "rincko"
          partner_type: "youtuber",
          comission: "20_percent",
        }),
      });

      const data = await response.json();

      if (data.success && data.url) {
        trackEvent("partner_checkout_click", {
          partner: partner.name,
          tier: tier,
          bot_id: selectedBotId,
        });
        window.location.href = data.url;
      } else {
        alert(data.error || "Erro ao iniciar checkout. Tente novamente.");
      }
    } catch (err) {
      console.error("Erro no checkout de parceiro:", err);
      alert("Erro de conexão. Tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-landing-page" style={{ "--partner-color": purePartnerColor }}>
      <div
        className="hero-overlay"
        style={{
          background: `radial-gradient(circle at 50% -20%, ${purePartnerColor}26, transparent 70%)`,
        }}
      ></div>

      <div className="container py-5">
        {/* Header da Parceria */}
        <div className="partner-header text-center mb-5">
          <div className="logos-wrapper d-flex justify-content-center align-items-center mb-4">
            <img src="/logo.png" alt="BotGate" className="main-logo" />
            <span
              className="plus-sign"
              style={{
                color: purePartnerColor,
                textShadow: `0 0 10px ${purePartnerColor}80`,
              }}
            >
              ×
            </span>
            <img src={partner.avatar} alt={partner.name} className="partner-logo" />
          </div>
          <h1 className="display-4 fw-bold">
            BotGate ×{" "}
            <span
              className="partner-name-color"
              style={{
                color: purePartnerColor,
                textShadow: `0 0 15px ${purePartnerColor}66`,
              }}
            >
              {partner.name}
            </span>
          </h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
            {t(`partnerLanding.descriptions.${partnerName.toLowerCase()}`, {
              defaultValue: partner.description,
            })}
          </p>
          <div className="partner-socials d-flex justify-content-center gap-3 mt-3">
            {partner.socials.youtube && (
              <a href={partner.socials.youtube} target="_blank" rel="noreferrer" className="social-btn yt" title="YouTube">
                <span>📺</span>
              </a>
            )}
            {partner.socials.instagram && (
              <a href={partner.socials.instagram} target="_blank" rel="noreferrer" className="social-btn ig" title="Instagram">
                <span>📸</span>
              </a>
            )}
            {partner.socials.github && (
              <a href={partner.socials.github} target="_blank" rel="noreferrer" className="social-btn gh" title="GitHub">
                <span>💻</span>
              </a>
            )}
            {partner.socials.discord && (
              <a href={partner.socials.discord} target="_blank" rel="noreferrer" className="social-btn dc" title="Discord">
                <span>💬</span>
              </a>
            )}
          </div>
        </div>

        {/* Seleção do Bot (Caso logado) */}
        {user ? (
          <div className="bot-selection-section mb-5 text-center">
            <h3 className="mb-4">{t("partnerLanding.selectBotTitle")}</h3>
            {bots.length > 0 ? (
              <div className="bot-selector-container mx-auto" style={{ maxWidth: "500px" }}>
                <select className="form-select form-select-lg partner-bot-select" value={selectedBotId} onChange={(e) => setSelectedBotId(e.target.value)}>
                  {bots.map((bot) => (
                    <option key={bot.id} value={bot.id}>
                      {bot.name} ({bot.apiTier || "Free"})
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="alert alert-warning d-inline-block">
                <Trans i18nKey="partnerLanding.noBotsWarning">
                  Você ainda não tem bots cadastrados. <Link to="/add-bot">Cadastre um agora!</Link>
                </Trans>
              </div>
            )}

            {/* Aviso de Plano Ativo (Igual ao CheckoutPage) */}
            {(() => {
              const selectedBot = bots.find((b) => b.id === selectedBotId);
              if (selectedBot && selectedBot.apiTier && selectedBot.apiTier !== "free") {
                const limit = selectedBot.apiTier === "business" ? 100000 : selectedBot.apiTier === "premium" ? 10000 : 1500;
                const used = selectedBot.apiCallsThisMonth || 0;
                const remaining = Math.max(0, limit - used);

                return (
                  <div className="plan-active-warning mx-auto mt-4" style={{ maxWidth: "700px", textAlign: "left" }}>
                    <div className="warning-header">
                      <span>⚠️</span> {t("checkout.activePlanWarning.title")}
                    </div>
                    <div className="warning-details">
                      <p className="warning-bot-desc">
                        <Trans
                          i18nKey="checkout.activePlanWarning.description"
                          values={{
                            botName: selectedBot.name,
                            apiTier: selectedBot.apiTier,
                          }}
                          defaults="O bot <0>{{botName}}</0> está atualmente no plano <1>{{apiTier}}</1>."
                          components={{
                            0: <strong />,
                            1: <strong style={{ textTransform: "uppercase" }} />,
                          }}
                        />
                      </p>

                      <div
                        className="warning-danger-box"
                        style={{
                          background: "rgba(240, 71, 71, 0.1)",
                          border: "1px solid rgba(240, 71, 71, 0.3)",
                          padding: "1rem",
                          borderRadius: "8px",
                          marginBottom: "1rem",
                          fontSize: "0.9rem",
                          color: "#f04747",
                        }}
                      >
                        <strong>{t("checkout.activePlanWarning.important")}</strong> {t("checkout.activePlanWarning.riskTitle")}
                        <ul
                          style={{
                            marginTop: "0.5rem",
                            listStyle: "inside disc",
                          }}
                        >
                          <li>
                            <Trans
                              i18nKey="checkout.activePlanWarning.risk1"
                              defaults="Você <0>perderá</0> o restante dos dias já pagos no plano atual."
                              components={{ 0: <strong /> }}
                            />
                          </li>
                          <li>{t("checkout.activePlanWarning.risk2")}</li>
                          <li>{t("checkout.activePlanWarning.risk3")}</li>
                          <li>
                            <Trans
                              i18nKey="checkout.activePlanWarning.risk4"
                              defaults="<0>RISCO DE COBRANÇA DUPLA:</0> Você receberá <1>duas faturas simultâneas</1> no seu cartão nos meses seguintes se não cancelar a assinatura antiga manualmente na Stripe."
                              components={{
                                0: <strong />,
                                1: <strong />,
                              }}
                            />
                          </li>
                        </ul>
                      </div>

                      <div className="warning-stats-grid">
                        <div className="warning-stat-card">
                          <span className="stat-label">{t("checkout.activePlanWarning.statusLabel")}</span>
                          <span className="stat-value">
                            {selectedBot.cancelAtPeriodEnd ? t("checkout.activePlanWarning.statusPending") : t("checkout.activePlanWarning.statusActive")}
                          </span>
                        </div>
                        <div className="warning-stat-card">
                          <span className="stat-label">{t("checkout.activePlanWarning.expiresLabel")}</span>
                          <span className="stat-value">
                            {selectedBot.expiresAt ? new Date(selectedBot.expiresAt).toLocaleDateString(t("language") === "en" ? "en-US" : "pt-BR") : "N/A"}
                          </span>
                        </div>
                        <div className="warning-stat-card">
                          <span className="stat-label">{t("checkout.activePlanWarning.apiTotalLabel")}</span>
                          <span className="stat-value">{limit.toLocaleString()}</span>
                        </div>
                        <div className="warning-stat-card">
                          <span className="stat-label">{t("checkout.activePlanWarning.remainingLabel")}</span>
                          <span className="stat-value highlight">{remaining.toLocaleString()}</span>
                        </div>
                      </div>

                      <div className="warning-footer">{t("checkout.activePlanWarning.footer")}</div>
                    </div>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        ) : (
          <div className="login-prompt text-center mb-5">
            <button className="btn btn-discord btn-lg" onClick={() => authService.login()}>
              {t("partnerLanding.loginPrompt")}
            </button>
            <p className="mt-2 text-white small">{t("partnerLanding.loginHelp")}</p>
          </div>
        )}

        {/* Cards de Preço Exclusivos */}
        <div className="row justify-content-center g-4">
          <div className="col-md-5 col-lg-4">
            <div className="partner-price-card premium">
              <div className="card-badge">{t("partnerLanding.mostPopular")}</div>
              <div className="card-header-icon">⭐</div>
              <h3>{t("partnerLanding.premiumTier")}</h3>
              <div className="price-tag">
                <span className="currency">R$</span>
                <span className="value">9,99</span>
                <span className="period">{t("partnerLanding.perMonth")}</span>
              </div>
              <ul className="benefits-list">
                {t("partnerLanding.premiumFeatures", {
                  returnObjects: true,
                }).map((feat, idx) => (
                  <li key={idx}>✓ {feat}</li>
                ))}
              </ul>
              <button className="btn btn-premium-glow w-100 btn-lg mt-4" onClick={() => handlePartnerCheckout("premium")}>
                {t("partnerLanding.activateWith", { name: partner.name })}
              </button>
            </div>
          </div>

          <div className="col-md-5 col-lg-4">
            <div className="partner-price-card business">
              <div className="card-header-icon">🚀</div>
              <h3>{t("partnerLanding.businessTier")}</h3>
              <div className="price-tag">
                <span className="currency">R$</span>
                <span className="value">29,99</span>
                <span className="period">{t("partnerLanding.perMonth")}</span>
              </div>
              <ul className="benefits-list">
                {t("partnerLanding.businessFeatures", {
                  returnObjects: true,
                }).map((feat, idx) => (
                  <li key={idx}>✓ {feat}</li>
                ))}
              </ul>
              <button className="btn btn-business-glow w-100 btn-lg mt-4" onClick={() => handlePartnerCheckout("business")}>
                {t("partnerLanding.activateWith", { name: partner.name })}
              </button>
            </div>
          </div>
        </div>

        <div className="trust-section text-center mt-5 pt-4">
          <div className="trust-divider mb-4"></div>
          <p className="trust-text mb-3">{t("partnerLanding.trustTitle")}</p>
          <div className="stripe-badge-wrapper">
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" alt="Stripe" className="stripe-logo-img" />
          </div>
          <div className="security-features mt-3 d-flex justify-content-center gap-4">
            <span className="sec-item">🔒 {t("partnerLanding.ssl")}</span>
            <span className="sec-item">🛡️ {t("partnerLanding.dataProtection")}</span>
            <span className="sec-item">💳 {t("partnerLanding.directCheckout")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerLandingPage;
